import { useParams } from 'react-router-dom';
import ExpenseForm from '../../components/expenseForm.mjs';
import ClaimQuestionsBanner from '../../clarifications/components/ClaimQuestionsBanner.mjs';



const AdminExpenseEdit = () => {
  const { claimId } = useParams();

  // ExpenseForm renders the page frame: its band reads "Admin Edit: Expense
  // Claim" for admins here, and "Expense Claim" for auditors, who open claims
  // through this same route read-only. Open clarification questions on the
  // claim show at the top of it - this is where the reviewers' links land.
  return (
    <ExpenseForm
      adminMode={true}
      questionsBanner={<ClaimQuestionsBanner claimType="ExpenseClaim" claimId={claimId} />}
    />
  );
};

export default AdminExpenseEdit;
